import { render, staticRenderFns } from "./BlockTagsController.vue?vue&type=template&id=a3cb6050&scoped=true&"
import script from "./BlockTagsController.vue?vue&type=script&lang=ts&"
export * from "./BlockTagsController.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTagsController.vue?vue&type=style&index=0&id=a3cb6050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cb6050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
